"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Container = styled_components_1.default.div `
  position: absolute;
  left: 10vh;
  bottom: 10vh;
  padding: 16px;
  background-color: white;
  border: 1px black solid;
  width: 80vh;
`;
const Title = styled_components_1.default.h1 `
  font-family: CatV, monospace;
`;
const Text = styled_components_1.default.p `
  font-family: CatV, monospace;
`;
const ActionsList = styled_components_1.default.div `
  display: flex;
  justify-content: flex-end;
`;
const ActionButton = styled_components_1.default.div `
  outline: none;
  border: 1px solid black;
  margin: 16px;
  padding: 8px;
  font-family: CatV, monospace;
  color: black;
  cursor: pointer;

  &:hover {
    color: #fa00dd;
  }
`;
const SignUI = ({ sign, invokeAction }) => {
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(Title, null, sign.title),
        react_1.default.createElement(Text, null, sign.text),
        react_1.default.createElement(ActionsList, null, sign.actions.map((action) => (react_1.default.createElement(ActionButton, { key: action.value, onClick: () => invokeAction(action.value) }, action.label))))));
};
exports.default = SignUI;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2lnblVJLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NsaWVudC9TaWduVUkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsa0RBQWlEO0FBQ2pELDBFQUF1QztBQUd2QyxNQUFNLFNBQVMsR0FBRywyQkFBTSxDQUFDLEdBQUcsQ0FBQTs7Ozs7Ozs7Q0FRM0IsQ0FBQztBQUVGLE1BQU0sS0FBSyxHQUFHLDJCQUFNLENBQUMsRUFBRSxDQUFBOztDQUV0QixDQUFDO0FBRUYsTUFBTSxJQUFJLEdBQUcsMkJBQU0sQ0FBQyxDQUFDLENBQUE7O0NBRXBCLENBQUM7QUFFRixNQUFNLFdBQVcsR0FBRywyQkFBTSxDQUFDLEdBQUcsQ0FBQTs7O0NBRzdCLENBQUM7QUFFRixNQUFNLFlBQVksR0FBRywyQkFBTSxDQUFDLEdBQUcsQ0FBQTs7Ozs7Ozs7Ozs7O0NBWTlCLENBQUM7QUFPRixNQUFNLE1BQU0sR0FBNkIsQ0FBQyxFQUFFLElBQUksRUFBRSxZQUFZLEVBQVMsRUFBRSxFQUFFO0lBQ3pFLE9BQU8sQ0FDTCw4QkFBQyxTQUFTO1FBQ1IsOEJBQUMsS0FBSyxRQUFFLElBQUksQ0FBQyxLQUFLLENBQVM7UUFDM0IsOEJBQUMsSUFBSSxRQUFFLElBQUksQ0FBQyxJQUFJLENBQVE7UUFDeEIsOEJBQUMsV0FBVyxRQUNULElBQUksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsTUFBTSxFQUFFLEVBQUUsQ0FBQyxDQUM1Qiw4QkFBQyxZQUFZLElBQUMsR0FBRyxFQUFFLE1BQU0sQ0FBQyxLQUFLLEVBQUUsT0FBTyxFQUFFLEdBQUcsRUFBRSxDQUFDLFlBQVksQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLElBQ3ZFLE1BQU0sQ0FBQyxLQUFLLENBQ0EsQ0FDaEIsQ0FBQyxDQUNVLENBQ0osQ0FDYixDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsa0JBQWUsTUFBTSxDQUFDIn0=